class Controller {
  constructor($injector, $stateParams, BulkBonusesTransforms) {
    "ngInject";

    this.Events = $injector.get("Events");
    this.$stateParams = $stateParams;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.paginateEvent = this.Events.getPaginateEvent("bulkbonuses");

    this.fields = BulkBonusesTransforms.fields;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkBonuses/bulkBonuses.controller.js